import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { seApi } from "./features/api/apiSlice";
import apiKeyReducer from "./features/api/apiKeySlice";

export const store = configureStore({
    reducer: {
        apiKey: apiKeyReducer,
        [seApi.reducerPath]: seApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(seApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
